import { render } from "./FooterTab.vue?vue&type=template&id=7a608e1d"
import script from "./FooterTab.vue?vue&type=script&lang=js"
export * from "./FooterTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__